// extracted by mini-css-extract-plugin
export default {"form_box":"styles_form_box__Br4Z6","title":"styles_title__2ljOM","desc":"styles_desc__vCYWj"};